import React from "react";
import {
  isMultipleChoiceQuestion,
  mcqOptionsForDisplay,
} from "../utils/quizQuestionCompatibility";
import "./QuizMcqPreview.css";

const QuizMcqPreview = ({ question, showOptions = false }) => {
  if (!isMultipleChoiceQuestion(question)) return null;

  const options = mcqOptionsForDisplay(question);

  return (
    <div className="quiz-mcq-preview">
      <div className="quiz-mcq-summary">
        <span className="quiz-mcq-type-badge">Multiple Choice</span>
        <span className="quiz-mcq-option-count">
          {options.length} option{options.length === 1 ? "" : "s"}
        </span>
      </div>
      {showOptions && (
        <ol className="quiz-mcq-option-list" aria-label="Multiple-choice options">
          {options.map((option) => (
            <li key={option.id || option.label}>
              <span className="quiz-mcq-option-label" aria-hidden="true">{option.label}</span>
              <span>{option.text || "Empty option"}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default QuizMcqPreview;
